import * as React from "react";
import * as ReactDOM from "react-dom";
import { defineCustomTags } from "sb-helpers";
defineCustomTags("sb-resp-popup-portal");
export class PopupPortal extends React.Component {
    constructor(props) {
        super(props);
        this.portalElem = document.createElement("sb-resp-popup-portal");
        this.portalElem.className = `rj-popup-portal ${props.className}`;
    }
    componentWillUnmount() {
        this
            .props
            .popupPortalEl
            .removeChild(this.portalElem);
    }
    componentDidMount() {
        this
            .props
            .popupPortalEl
            .appendChild(this.portalElem);
    }
    render() {
        return (ReactDOM.createPortal(this.props.children, this.portalElem));
    }
}
//# sourceMappingURL=PopupPortal.js.map